module.exports = __webpack_public_path__ + "static/media/24.ab77eaf1.png";